import { render } from "./TheAdminProfessionalCreate.vue?vue&type=template&id=188f9912&ts=true"
import script from "./TheAdminProfessionalCreate.vue?vue&type=script&lang=ts"
export * from "./TheAdminProfessionalCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__